var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"break"},[_c('div',{staticClass:"break__divider"}),_c('div',{staticClass:"break__skillcheck-wrapper"},[_c('SkillCheckIcon',{staticClass:"break__skillcheck-icon"})],1),_c('div',{staticClass:"break__divider"})])}
var staticRenderFns = []

export { render, staticRenderFns }